import React from 'react';
// import { NavLink } from 'react-router-dom';
import flaticon1 from '../../images/icon/icon1.png';
import flaticon2 from '../../images/icon/icon2.jpg';
import flaticon3 from '../../images/icon/icon3.jpeg';
import flaticon4 from '../../images/icon/icon4.png';
import flaticon5 from '../../images/icon/icon9.jpg';
// import flaticon6 from '../../images/icon/icon6.png';
import flaticon7 from '../../images/icon/icon7.jpg';
// import flaticon8 from '../../images/icon/icon8.jpg';

const services = [
    {
        count: 1,
        title: 'Wardrobes',
        flaticon: flaticon2,
        description: 'lorem Ipsum available, but the majority have suffered alteration in some form, by various by accident.',
    },
    {
        count: 2,
        title: 'Home Office',
        flaticon: flaticon7,
        description: 'lorem Ipsum available, but the majority have suffered alteration in some form, by various by accident.',
    },
    {
        count: 3,
        title: 'Kitchen',
        flaticon: flaticon1,
        description: 'lorem Ipsum available, but the majority have suffered alteration in some form, by various by accident.',
    },
    {
        count: 4,
        title: 'Media Wall',
        flaticon: flaticon3,
        description: 'lorem Ipsum available, but the majority have suffered alteration in some form, by various by accident.',
    },
    {
        count: 5,
        title: 'Loft Conversion',
        flaticon: flaticon4, // Replace this with background image for the card
        description: 'lorem Ipsum available, but the majority have suffered alteration in some form, by various by accident.',
    },
    {
        count: 6,
        title: 'UnderStairs and More',
        flaticon: flaticon5,
        description: 'lorem Ipsum available, but the majority have suffered alteration in some form, by various by accident.',
    },
   
    // {
    //     count: 7,
    //     title: 'Office',
    //     flaticon: flaticon7,
    //     description: 'lorem Ipsum available, but the majority have suffered alteration in some form, by various by accident.',
    // },
    // {
    //     count: 8,
    //     title: 'Bookshelves',
    //     flaticon: flaticon8,
    //     description: 'lorem Ipsum available, but the majority have suffered alteration in some form, by various by accident.',
    // }
]

var img1 = require('./../../images/background/bg-5.png');
// var img2 = require('./../../images/background/line.png');// Replace with appropriate image or link

class OurServices4 extends React.Component {
    componentDidMount() {
        function loadScript(src) {
            return new Promise(function (resolve, reject) {
                var script = document.createElement('script');
                script.src = src;
                script.addEventListener('load', function () {
                    resolve();
                });
                script.addEventListener('error', function (e) {
                    reject(e);
                });
                document.body.appendChild(script);
                document.body.removeChild(script);
            })
        };
        loadScript('./assets/js/masonary.js');
    };

    render() {
        return (
            <>
                 <div className="section-full p-t80 p-b50 bg-dark mobile-page-padding" style={{ backgroundImage: 'url(' + img1 + ')' }}>
                <div className="container">
                    <div className="section-head">
                        <div className="mt-separator-outer separator-center">
                            <div className="mt-separator">
                                <h2 className="text-uppercase sep-line-one text-white"><span className="font-weight-300 text-primary">All</span> Services</h2>
                            </div>
                        </div>
                    </div>
                    {/* IMAGE CAROUSEL START */}
                    <div className="section-content">
                        <div className="row">
                            {services.map((item, index) => (
                                <div key={index} className="col-md-4 col-sm-6">
                                    <div
                                        className="mt-icon-box-wraper center m-b30 bg-white"
                                        style={{
                                            backgroundImage: `url(${item.flaticon})`,
                                            backgroundSize: 'cover',
                                            backgroundPosition: 'center center',
                                            height: '250px',  // Set your desired height
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            position: 'relative',
                                            color: 'white',
                                            textAlign: 'center',
                                            padding: '20px',
                                            boxSizing: 'border-box',
                                            borderRadius: '10px'
                                        }}
                                    >
                                        {/* Optionally add an overlay to improve text visibility */}
                                        <div
                                            style={{
                                                position: 'absolute',
                                                top: 0,
                                                left: 0,
                                                right: 0,
                                                bottom: 0,
                                                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                                zIndex: 1,
                                                borderRadius: '10px'
                                            }}
                                        />
                                        <h4 className="mt-title text-uppercase font-weight-600 m-b20" style={{ zIndex: 2, color: 'white' }}>
                                            {item.title}
                                        </h4>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div >
            </>
        );
    }
}

export default OurServices4;
